import { lazyLoad } from '../../utils/loadable';
export var BillingPage = lazyLoad(function () { return import('./Billing'); }, function (module) { return module.Billing; });
export var PaymentDetailsPage = lazyLoad(function () { return import('./PaymentDetails'); }, function (module) { return module.PaymentDetails; });
export var PaymentExtensionPage = lazyLoad(function () { return import('./PaymentExtension'); }, function (module) { return module.PaymentExtension; });
